import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useCallback, useEffect, useRef, useState } from "react";

export default function useContextMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const menuRef = useRef<HTMLDivElement>(null);
  const [itemForContextMenu, setItemForContextMenu] = useState<InventoryItem | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleContextMenu = useCallback((e: React.MouseEvent, item: InventoryItem) => {
    e.preventDefault();
    setIsOpen(true);
    setPosition({ x: e.clientX, y: e.clientY });
    setItemForContextMenu(item);
  }, []);

  const closeContextMenu = useCallback(() => {
    setIsOpen(false);
    setItemForContextMenu(null);
  }, []);

  return {
    menuRef,
    isOpen,
    position,
    handleContextMenu,
    itemForContextMenu,
    closeContextMenu,
  };
}
